import { richTextResolver } from '@storyblok/richtext'
import type { StoryblokRichTextResolvers } from '@storyblok/richtext'
import type { VNode } from 'vue'
import { createTextVNode } from 'vue'
import { defineResolvers } from '#layers/storyblok/app/utils'

export const useRenderer = (resolvers: StoryblokRichTextResolvers<VNode> = {}) => {
  const _resolvers = defineResolvers(resolvers)

  return richTextResolver<VNode>({
    renderFn: h,
    textFn: createTextVNode,
    resolvers: _resolvers,
  })
}
